<template>
  <v-dialog :value="value" max-width="600" @input="$emit('input', $event)">
    <v-card class="ga-warning">
      <v-card-title class="headline">{{ adminText('organizationAll.ga_warning_title', 'Subscription without performances') }}</v-card-title>
      <v-card-text>{{ adminText('organizationAll.ga_empty_warning', 'This subscription has no included performances. You can save it, but sales remain unavailable until performances with capacity are added. You may enable Active manually.') }}</v-card-text>
      <v-card-actions class="ga-warning-actions">
        <main-button flat @click="$emit('input', false)">{{ adminText('organizationAll.ga_back', 'Back') }}</main-button>
        <v-spacer />
        <main-button depressed color="primary" @click="$emit('confirm')">{{ active ? adminText('organizationAll.ga_save_active', 'Save active subscription') : adminText('organizationAll.ga_save_inactive', 'Save inactive subscription') }}</main-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import MainButton from '@/components/shared/main-button.vue'
import OrganizationLocalization from '@/components/organizations/organization-all-display'
export default {
  components: { MainButton },
  mixins: [OrganizationLocalization],
  props: { value: Boolean, active: Boolean },
}
</script>
<style scoped>
.ga-warning { font-family: 'Source Sans Pro', sans-serif; }
.ga-warning > .v-card__title { padding: 24px 24px 12px; font-size: 20px !important; line-height: 1.4 !important; }
.ga-warning > .v-card__text { padding: 0 24px 24px; font-size: 16px; line-height: 1.5; color: #52616b; }
.ga-warning-actions { padding: 16px 24px; gap: 12px; border-top: 1px solid #e8edf0; flex-wrap: wrap; }
.ga-warning-actions >>> .main-button { margin: 0; font-size: 13px; min-height: 44px; }
@media (max-width: 599px) {
  .ga-warning > .v-card__title { padding: 20px 20px 12px; font-size: 20px !important; overflow-wrap: anywhere; }
  .ga-warning > .v-card__text { padding: 0 20px 20px; }
  .ga-warning-actions { padding: 12px 20px; }
  .ga-warning-actions >>> .v-btn__content { white-space: normal; line-height: 1.35; }
  .ga-warning-actions >>> .main-button { height: auto; padding-top: 12px; padding-bottom: 12px; }
  .ga-warning-actions { flex-direction: column-reverse; align-items: stretch; }
  .ga-warning-actions > .spacer { display: none; }
  .ga-warning-actions >>> .main-button { width: 100%; }
}
</style>
